import { Component } from 'preact';
import { IntlProvider } from 'react-intl'
import {
	WfGroupReview,
	/* WfPeerRecommendations, */
	WfHorizontal,
	WfGrid,
	WfCarousel,
	WfMicroStar,
	WfDoctifyList,
	ReviewBadge,
	V2AverageRating,
	V2AverageKeywordRating,
	V2AverageCategoryRating,
	V2AverageRatingCarousel,
} from "./containers";
import { apiUrl, dashboardUrl } from './constants';
import BadgeButton from "./components/personalized/badge-button";
import Badge from "./components/personalized/badge";
import { ProfileFilters } from './components/filters';
import WidgetsImagePlaceholder from './components/personalized/widgets-image-placeholder';
import { isVisible } from './utils/is-visible';
import { throttle } from './utils/throttle';
import i18n, { __ } from '../locales';
import { headerBase64, styledBackgroundBase64, badgesExampleBase64, bannersExampleBase64, carouselsExampleBase64 } from './images';

const getDefaultProfileState = () => {
	const [, tenant, profileType, slug, profileName = ''] = window.location.pathname.split('/')

	return {
		tenant,
		profileType,
		slug,
		profileName: decodeURIComponent(profileName)
	}
}

class WidgetsApp extends Component {
	constructor(props) {
		super(props);
		this.themeList = ['darkNavy', 'lightBlue', 'white', 'transparent', 'gradientBlue']
		this.tenantsList = [
			{
				name: 'athena-uk',
				languages: ['en'],
				url: 'uk',
			},
			{
				name: 'athena-uae',
				languages: ['en', 'ar'],
				url: 'en-ae',
			},
			{
				name: 'athena-at',
				languages: ['de'],
				url: 'de-at',
			},
			{
				name: 'athena-de',
				languages: ['de'],
				url: 'de',
			},
			{
				name: 'athena-au',
				languages: ['en'],
				url: 'au',
				tenantUrlEnabled: true,
			},
			{
				name: 'athena-ie',
				languages: ['en'],
				url: 'ie',
			},
			{
				name: 'athena-sa',
				languages: ['en', 'ar'],
				url: 'sa',
			}
		];
		this.state = {
			selectedProfiles: [],
			inputs: {
				theme: 'darkNavy',
				tenant: this.tenantsList[0].name,
				language: this.tenantsList[0].languages[0],
				profileType: '',
				linkUrl: '',
				slug: '',
				outerFrame: false,
				itemFrame: true,
				background: 'white',
				itemBackground: '#ffffff',
				dotsArrowsColor: '4C5870',
				slugs: '',
				rating: 0,
				smaller: false,
				logo: true,
				keyword: null,
			},
			selectedTenant: this.tenantsList[0],
			selectedLanguage: this.tenantsList[0].languages[0],
			profileTypes: ['practice', 'specialist'],
			backgroundOptions: [],
			searchData: { practices: [], specialists: [] },
			keywords: [],
			prepopulated: false
		}
		i18n.changeLanguage(this.tenantsList[0].languages[0])
	}

	componentDidMount() {
		const { tenant, profileType, slug, profileName } = getDefaultProfileState()
		if (tenant && profileType && slug) {
			const selectedTenant = this.tenantsList.find(f => f.name === tenant)
			this.setState({
				prepopulated: true,
				selectedProfiles: [{ label: profileName || slug, value: slug }],
				selectedTenant,
				selectedLanguage: selectedTenant?.languages?.[0],
				inputs: {
					...this.state.inputs,
					tenant,
					profileType,
					slug,
					slugs: [slug],
					language: selectedTenant?.languages?.[0]
				}
			}, () => {
				this.changeLanguage(selectedTenant?.languages?.[0])
				this.setState({
					backgroundOptions: [
						{ label: __('theme.transparent'), value: 'transparent' },
						{ label: __('theme.white'), value: '#000' }
					]
				})
			})
		} else {
			this.setState({
				backgroundOptions: [
					{ label: __('theme.transparent'), value: 'transparent' },
					{ label: __('theme.white'), value: '#000' }
				]
			}, () => {
				this.fetchTenantData()
			})
		}

		const headerSection = document.querySelector('#headerSection')
		const badgesSection = document.querySelector('#badgesSection')
		const bannersSection = document.querySelector('#bannersSection')
		const carouselsSection = document.querySelector('#carouselsSection')
		const badgesButton = document.querySelector('#badgesButton')
		const bannersButton = document.querySelector('#bannersButton')
		const carouselsButton = document.querySelector('#carouselsButton')

		const scrollHandler = () => {
			if (isVisible(headerSection)) {
				badgesButton.classList.remove('active')
				bannersButton.classList.remove('active')
				carouselsButton.classList.remove('active')
			}
			else if (isVisible(badgesSection)) {
				badgesButton.classList.add('active')
				bannersButton.classList.remove('active')
				carouselsButton.classList.remove('active')
			} else if (isVisible(bannersSection)) {
				bannersButton.classList.add('active')
				badgesButton.classList.remove('active')
				carouselsButton.classList.remove('active')
			} else if (isVisible(carouselsSection)) {
				carouselsButton.classList.add('active')
				badgesButton.classList.remove('active')
				bannersButton.classList.remove('active')
			} else {
				badgesButton.classList.remove('active')
				bannersButton.classList.remove('active')
				carouselsButton.classList.remove('active')
			}
		}
		window.addEventListener('scroll', throttle(scrollHandler, 200))
	}

	addProfile = profile => {
		this.setState(({ selectedProfiles, inputs }) => {
			const selectedNew = [...selectedProfiles, profile]
			return {
				selectedProfiles: selectedNew,
				inputs: {
					...inputs,
					slugs: selectedNew.map(({ value }) => value).join(',')
				}
			}
		})
	};
	removeProfile = value => {
		const profileIndex = this.state.selectedProfiles.findIndex(item => item.value === value);
		if (profileIndex !== -1) {
			const selectedProfiles = [
				...this.state.selectedProfiles.slice(0, profileIndex),
				...this.state.selectedProfiles.slice(profileIndex + 1)
			]
			this.setState({
				selectedProfiles,
				inputs: {
					...this.state.inputs,
					slugs: selectedProfiles.map(({ value }) => value).join(',')
				}
			})
		}
	};
	fetchTenantData = (searchString = '') => {
		const { selectedTenant } = this.state;
		if (!searchString || searchString.length > 3) {
			fetch(`${apiUrl}${selectedTenant.url}/api/search/autocomplete?searchString=${searchString}`)
				.then(res => res.json())
				.then(result => {
					this.setState({
						searchData: {
							practices: result.practices.map(practice => ({value: practice.slug, label: practice.name})),
							specialists: result.specialists.map(specialists =>
								({
									value: specialists.slug,
									label: {firstName: specialists.firstName, lastName: specialists.lastName}
								})
							),
						},
					})
				})
				.catch(err => {
					console.log(err)
				})
		}
	};

	moveMostSimilarUp(array, targetLabel) {
		let mostSimilarIndex = -1;
		let highestSimilarity = -1;

		array.forEach((item, index) => {
			const similarity = item.label.toLowerCase().includes(targetLabel.toLowerCase()) ? targetLabel.length : 0;
			if (similarity > highestSimilarity) {
				highestSimilarity = similarity;
				mostSimilarIndex = index;
			}
		});

		if (mostSimilarIndex > -1) {
			const [itemToMove] = array.splice(mostSimilarIndex, 1);
			array.unshift(itemToMove);
		}

		return array;
	}

	fetchKeywords = (searchString = '') => {
		const { selectedTenant, selectedLanguage } = this.state;
		if (!searchString || searchString.length > 3) {
			fetch(`${apiUrl}${selectedTenant.url}/api/search/autocomplete?searchString=${searchString}`)
				.then(res => res.json())
				.then(result => {
					this.setState({
						keywords: this.moveMostSimilarUp([
							...result['conditions-procedures'],
							...result['specialties'],
						]
							.map(c => ({
								value: c.name?.[selectedLanguage],
								label: c.name?.[selectedLanguage],
							})), searchString)
					})
				})
				.catch(err => {
					console.log(err)
				})
		}
	};
	onInputsChange = (key, value) => {
		if (key === 'rating' && (Number(value) < 0 || Number(value) > 5)) {
			value = Number(value) < 0 ? 0 : 5
		}
		this.setState({ inputs: { ...this.state.inputs, [key]: value } })
	};

	getTranslate = obj => {
		return obj[this.state.selectedLanguage] ? obj[this.state.selectedLanguage] : obj[Object.keys(obj)[0]]
	};

	translateData = (data = [], isSpecialists = false) => {
		if (isSpecialists) {
			return data.map(spec => ({
				value: spec.value,
				label: `${this.getTranslate(spec.label.firstName)} ${this.getTranslate(spec.label.lastName)}`
			}))
		}
		return data.map(pract => ({
			value: pract.value,
			label: this.getTranslate(pract.label)
		}))
	};

	changeProfileType = profileType => {
		this.setState({ inputs: { ...this.state.inputs, profileType, slug: null, slugs: '' }, selectedProfiles: []})
	};

	changeTenant = tenant => {
		this.setState({
			selectedTenant: tenant,
			selectedProfiles: [],
			inputs: {
				...this.state.inputs,
				tenant: tenant.name,
				profileType: '',
				slug: '',
				slugs: ''
			}
		}, () => {
			this.fetchTenantData();
			this.changeLanguage(tenant.languages[0])
		});
	};

	changeTheme = theme => {
		this.setState({
			inputs: {
				...this.state.inputs,
				theme,
			}
		})
	}

	changeLanguage = lang => {
		i18n.changeLanguage(lang)
		this.setState({
			selectedLanguage: lang,
			backgroundOptions: [
				{ label: __('theme.transparent'), value: 'transparent' },
				{ label: __('theme.white'), value: '#000' }
			],
			inputs: {
				...this.state.inputs,
				language: lang
			}
		})
	};

	scrollTo = (selector) => {
		const element = document.querySelector(selector)
		if (!element) {
			return
		}

		const header = document.querySelector('.sticky')
		const headerHeight = header?.offsetHeight || 0

		const top = element.getBoundingClientRect().top + window.scrollY - headerHeight + 2
		window.scroll({
			top: top,
			behavior: 'smooth',
			block: 'center',
			inline: 'center'
		})
	}

	render(props, {
		inputs,
		profileTypes,
		backgroundOptions,
		searchData,
		selectedTenant,
		selectedLanguage,
		selectedProfiles,
		keywords,
	}) {
		const profilesList = inputs.profileType === 'practice' ?
			this.translateData(searchData.practices)
			: this.translateData(searchData.specialists, true);

		const carouselsAvailable = inputs.tenant !== 'athena-au'

		return (
			<div id="app">
				<IntlProvider locale={this.state.selectedLanguage} defaultLocale={this.state.selectedLanguage}>
					<div className={'global-header'}>
						<img
							onClick={() => window.open(dashboardUrl + this.state.selectedTenant?.url, '_blank')}
							alt={''}
							src={headerBase64}
						/>
					</div>
					<div className={'page-section'} style={{ backgroundColor: '#1A3586', position: 'relative' }}>
						<div className={'content'} style={{ padding: '60px 40px 20px 40px' }}>
							<div className={'widgets-image-placeholder-container'}>
								<WidgetsImagePlaceholder />
								<div className={'page-section-title text-white'}>{__('header.title')}</div>
								<div className={'page-section-subtitle text-white'}>
									{__('header.subtitle')}
								</div>
							</div>
						</div>
					</div>
					<div className={'page-section sticky'} style={{ backgroundColor: '#1A3586' }}>
						<div className={'content'} style={{ padding: '20px 40px' }}>
							<div className={'d-flex'} style={{ gap: '8px' }}>
								<BadgeButton
									id={'badgesButton'}
									className={'badges'}
									text={__('widget.type.badges')}
									onClick={() => this.scrollTo('#badges')}
								/>
								<BadgeButton
									id={'bannersButton'}
									className={'banners'}
									text={__('widget.type.banners')}
									onClick={() => this.scrollTo('#banners')}
								/>
								{carouselsAvailable ? (
									<BadgeButton
										id={'carouselsButton'}
										className={'carousels'}
										text={__('widget.type.carousels')}
										onClick={() => this.scrollTo('#carousels')}
									/>
								) : null}
							</div>
						</div>
					</div>
					<div className={'page-section'} style={{ backgroundColor: '#1A3586' }}>
						<div className={'content'} style={{ paddingTop: '30px' }} />
					</div>
					<div id={'headerSection'} className={'page-section'} style={{ background: '#FFFFFF' }}>
						<div className={'content setup-section with-separator-bottom'} style={{ padding: '15px 40px 50px 40px' }}>
							<div className={'d-flex'} style={{ height: '100%' }}>
								<p className={'section-header'} style={{ whiteSpace: 'nowrap' }}>{__('global.inputs.title')}</p>
								<img style={{ marginLeft: '-15px' }} alt={''} src={styledBackgroundBase64}/>
							</div>
							<div className="d-flex flex-wrap" style={{ gap: '25px', alignItems: 'center' }}>
								{!this.state.prepopulated && (
									<div className={'input-component'}>
										<label>Select Tenant: </label>
										<select className="form-control" value={selectedTenant.name} onInput={(ev => {
											const tenantToSet = this.tenantsList.find(t => t.name === ev.target.value);
											this.changeTenant(tenantToSet)
										})}>
											{this.tenantsList.map(tenant => (
												<option value={tenant.name}>{tenant.name}</option>
											))}
										</select>
									</div>
								)}
								<ProfileFilters
									inputs={inputs}
									changeProfileType={this.changeProfileType}
									profileTypes={profileTypes}
									profilesList={profilesList}
									selectedProfiles={selectedProfiles}
									addProfile={this.addProfile}
									removeProfile={this.removeProfile}
									onAutocompleteSearch={this.fetchTenantData}
									prepopulated={this.state.prepopulated}
								/>
								{selectedTenant.languages.length > 1 ? <div className={'input-component'}>
									<label>{__('global.language')}: </label>
									<select className="form-control" value={selectedLanguage} onInput={(ev => {
										this.changeLanguage(ev.target.value);
									})}>
										{selectedTenant.languages.map(lang => (
											<option value={lang}>{__(`global.${lang}`)}</option>
										))}
									</select>
								</div> : null}
							</div>
						</div>
						<div className={'content'} style={{ padding: '60px 40px' }}>
							<div>
								<div className={'page-section-medium-title text-black'}>
									{__('widgets_description.title')}
								</div>
								<div className={'d-flex flex-wrap mt-4'} style={{ gap: '40px' }}>
									<div className={'badge-description-container'}>
										<div>
											<Badge
												onClick={() => this.scrollTo('#badges')}
												text={__('widget.type.badge')}
												fontColor={'#FFFFFF'}
												bgColor={'#00897D'}
											/>
											<div className={'page-section-text-regular mt-3'}>
												{__('widgets_description.badges')}
											</div>
										</div>
										<img style={{ maxWidth: '150px' }} alt={''} src={badgesExampleBase64}/>
									</div>
									<div className={'badge-description-container'}>
										<div>
											<Badge
												onClick={() => this.scrollTo('#banners')}
												text={__('widget.type.banner')}
												bgColor={'#FFC1BE'}
											/>
											<div className={'page-section-text-regular mt-3'}>
												{__('widgets_description.banners')}
											</div>
										</div>
										<img style={{ maxWidth: '310px' }} alt={''} src={bannersExampleBase64} />
									</div>
									{carouselsAvailable ? (
										<div className={'badge-description-container'}>
											<div>
												<Badge
													onClick={() => this.scrollTo('#carousels')}
													text={__('widget.type.carousel')}
													fontColor={'#FFFFFF'}
													bgColor={'#2B59E0'}
												/>
												<div className={'page-section-text-regular mt-3'}>
													{__('widgets_description.carousels')}
												</div>
											</div>
											<img style={{ maxWidth: '335px' }} alt={''} src={carouselsExampleBase64} />
										</div>
									) : null}
								</div>
							</div>
						</div>
					</div>
					<div className={'page-section'} style={{ background: '#F5F7FD' }}>
						<div className={'content'} style={{ padding: '0 40px 60px 40px' }}>
							<div className={'widgets-content'}>
								<div id={'badgesSection'} className={'widgets-content-section'}>
									<h1
										id={'badges'}
										className={'section-header'}
										style={{ backgroundColor: '#00897D', color: '#FFFFFF' }}
									>
										{__('widget.type.badges')}
									</h1>
									<V2AverageRating
										inputs={inputs}
										profileTypes={profileTypes}
										profilesList={profilesList}
										practicesList={this.translateData(searchData.practices)}
										onAutocompleteSearch={this.fetchTenantData}
										changeProfileType={this.changeProfileType}
										onInputsChange={this.onInputsChange}
										selectedProfiles={selectedProfiles}
										addProfile={this.addProfile}
										removeProfile={this.removeProfile}
										prepopulated={this.state.prepopulated}
										changeTheme={this.changeTheme}
										themeList={this.themeList}
									/>
									{!this.state.prepopulated && (
										<ReviewBadge
											inputs={inputs}
											profileTypes={profileTypes}
											onAutocompleteSearch={this.fetchTenantData}
											changeProfileType={this.changeProfileType}
											profilesList={profilesList}
											onInputsChange={this.onInputsChange}
											selectedProfiles={selectedProfiles}
											addProfile={this.addProfile}
											removeProfile={this.removeProfile}
											selectedTenant={selectedTenant}
											prepopulated={this.state.prepopulated}
										/>
									)}
									<WfMicroStar
										inputs={inputs}
										profileTypes={profileTypes}
										profilesList={profilesList}
										onAutocompleteSearch={this.fetchTenantData}
										changeProfileType={this.changeProfileType}
										backgroundOptions={backgroundOptions}
										onInputsChange={this.onInputsChange}
										selectedProfiles={selectedProfiles}
										addProfile={this.addProfile}
										removeProfile={this.removeProfile}
										selectedTenant={selectedTenant}
										prepopulated={this.state.prepopulated}
									/>
								</div>
								<div id={'bannersSection'} className={'widgets-content-section'}>
									<h1
										id={'banners'}
										className={'section-header'}
										style={{ backgroundColor: '#FFC1BE' }}
									>
										{__('widget.type.banners')}
									</h1>
									<V2AverageKeywordRating
										inputs={inputs}
										profileTypes={profileTypes}
										profilesList={profilesList}
										practicesList={this.translateData(searchData.practices)}
										onAutocompleteSearch={this.fetchTenantData}
										changeProfileType={this.changeProfileType}
										onInputsChange={this.onInputsChange}
										selectedProfiles={selectedProfiles}
										addProfile={this.addProfile}
										removeProfile={this.removeProfile}
										fetchKeywords={this.fetchKeywords}
										keywords={keywords}
										prepopulated={this.state.prepopulated}
										changeTheme={this.changeTheme}
										themeList={this.themeList}
									/>
									<V2AverageCategoryRating
										inputs={inputs}
										profileTypes={profileTypes}
										profilesList={profilesList}
										practicesList={this.translateData(searchData.practices)}
										onAutocompleteSearch={this.fetchTenantData}
										changeProfileType={this.changeProfileType}
										onInputsChange={this.onInputsChange}
										selectedProfiles={selectedProfiles}
										addProfile={this.addProfile}
										removeProfile={this.removeProfile}
										prepopulated={this.state.prepopulated}
										changeTheme={this.changeTheme}
										themeList={this.themeList}
									/>
									<WfHorizontal
										inputs={inputs}
										profileTypes={profileTypes}
										profilesList={profilesList}
										onAutocompleteSearch={this.fetchTenantData}
										changeProfileType={this.changeProfileType}
										backgroundOptions={backgroundOptions}
										onInputsChange={this.onInputsChange}
										selectedProfiles={selectedProfiles}
										addProfile={this.addProfile}
										removeProfile={this.removeProfile}
										selectedTenant={selectedTenant}
										prepopulated={this.state.prepopulated}
									/>
								</div>
								{carouselsAvailable ? (
									<div id={'carouselsSection'} className={'widgets-content-section'}>
										<h1
											id={'carousels'}
											className={'section-header'}
											style={{ backgroundColor: '#2B59E0', color: '#FFFFFF' }}
										>
											{__('widget.type.carousels')}
										</h1>
										<V2AverageRatingCarousel
											inputs={inputs}
											profileTypes={profileTypes}
											profilesList={profilesList}
											practicesList={this.translateData(searchData.practices)}
											onAutocompleteSearch={this.fetchTenantData}
											changeProfileType={this.changeProfileType}
											onInputsChange={this.onInputsChange}
											selectedProfiles={selectedProfiles}
											addProfile={this.addProfile}
											removeProfile={this.removeProfile}
											fetchKeywords={this.fetchKeywords}
											keywords={keywords}
											prepopulated={this.state.prepopulated}
											changeTheme={this.changeTheme}
											themeList={this.themeList}
										/>
										{!this.state.prepopulated && (
											<WfDoctifyList
												inputs={inputs}
												profileTypes={profileTypes}
												profilesList={profilesList}
												onAutocompleteSearch={this.fetchTenantData}
												changeProfileType={this.changeProfileType}
												backgroundOptions={backgroundOptions}
												onInputsChange={this.onInputsChange}
												selectedProfiles={selectedProfiles}
												addProfile={this.addProfile}
												removeProfile={this.removeProfile}
												selectedTenant={selectedTenant}
												prepopulated={this.state.prepopulated}
											/>
										)}
										<WfCarousel
											inputs={inputs}
											profileTypes={profileTypes}
											profilesList={profilesList}
											onAutocompleteSearch={this.fetchTenantData}
											changeProfileType={this.changeProfileType}
											backgroundOptions={backgroundOptions}
											onInputsChange={this.onInputsChange}
											selectedProfiles={selectedProfiles}
											addProfile={this.addProfile}
											removeProfile={this.removeProfile}
											selectedTenant={selectedTenant}
											prepopulated={this.state.prepopulated}
										/>
										<WfGrid
											inputs={inputs}
											profileTypes={profileTypes}
											profilesList={profilesList}
											onAutocompleteSearch={this.fetchTenantData}
											changeProfileType={this.changeProfileType}
											backgroundOptions={backgroundOptions}
											onInputsChange={this.onInputsChange}
											selectedProfiles={selectedProfiles}
											addProfile={this.addProfile}
											removeProfile={this.removeProfile}
											selectedTenant={selectedTenant}
											prepopulated={this.state.prepopulated}
										/>
										{/* <WfPeerRecommendations
											inputs={inputs}
											profileTypes={profileTypes}
											profilesList={profilesList}
											onAutocompleteSearch={this.fetchTenantData}
											changeProfileType={this.changeProfileType}
											backgroundOptions={backgroundOptions}
											onInputsChange={this.onInputsChange}
											selectedProfiles={selectedProfiles}
											addProfile={this.addProfile}
											removeProfile={this.removeProfile}
											selectedTenant={selectedTenant}
											prepopulated={this.state.prepopulated}
										/> */}
										{!this.state.prepopulated && this.state.inputs.profileType === 'practice' ? (
											<WfGroupReview
												inputs={inputs}
												profileTypes={profileTypes}
												profilesList={profilesList}
												practicesList={this.translateData(searchData.practices)}
												onAutocompleteSearch={this.fetchTenantData}
												changeProfileType={this.changeProfileType}
												backgroundOptions={backgroundOptions}
												onInputsChange={this.onInputsChange}
												selectedProfiles={selectedProfiles}
												addProfile={this.addProfile}
												removeProfile={this.removeProfile}
												selectedTenant={selectedTenant}
												prepopulated={this.state.prepopulated}
											/>
										) : null}
									</div>
								) : null}
							</div>
						</div>
					</div>
				</IntlProvider>
			</div>
		)
	}
}

export default WidgetsApp;
